/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*********************************************!*\
  !*** ./src/assets/js/newsletter-section.js ***!
  \*********************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NewsletterSection = /*#__PURE__*/function (_HTMLElement) {
  _inherits(NewsletterSection, _HTMLElement);

  var _super = _createSuper(NewsletterSection);

  function NewsletterSection() {
    var _this;

    _classCallCheck(this, NewsletterSection);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "removeParam", function (key, sourceURL) {
      var rtn = sourceURL.split("?")[0];
      var param;
      var params_arr = [];
      var queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";

      if (queryString !== "") {
        params_arr = queryString.split("&");

        for (var i = 0; i < params_arr.length; i++) {
          param = params_arr[i].split("=")[0];

          if (param !== key) {
            params_arr[i] = param + "=" + params_arr[i].split("=")[1];
          } else {
            params_arr.splice(i, 1);
            i--;
          }
        }

        if (params_arr.length > 0) {
          rtn = rtn + "?" + params_arr.join("&");
        }
      }

      return rtn;
    });

    _defineProperty(_assertThisInitialized(_this), "checkFormStatus", function () {
      if (window.location.href.indexOf('contact_posted=true') > -1 && window.location.href.indexOf('challenge') <= -1) {
        _this.showSuccessMessage();

        window.history.pushState({}, "", _this.removeParam('contact_posted', window.location.href));
      }

      if (window.location.href.indexOf('error=') > -1 || window.location.href.indexOf('contact_posted=false') > -1) {
        _this.showErrorMessage();

        window.history.pushState({}, "", _this.removeParam('contact_posted', window.location.href));
      }
    });

    _this.selectors = {
      baseContent: '[data-base-content]',
      successContent: '[data-success-content]',
      form: '.subscribe-form form',
      submitButton: "[data-newsletter-submit]",
      email: "[data-newsletter-email]",
      date: "[data-newsletter-date]",
      checkbox: ".custom-checkbox",
      emailError: '[data-email-error]',
      termsError: '[data-terms-error]',
      lastName: "[data-newsletter-last-name]",
      firstName: "[data-newsletter-first-name]"
    };
    _this.modificators = {
      active: "active"
    };
    _this.formId = null;
    return _this;
  }

  _createClass(NewsletterSection, [{
    key: "showSuccessMessage",
    value: function showSuccessMessage() {
      var baseContent = this.querySelector(this.selectors.baseContent);
      var successContent = this.querySelector(this.selectors.successContent);
      baseContent.classList.remove(this.modificators.active);
      successContent.classList.add(this.modificators.active);
      var Ycoords = this.getBoundingClientRect().top + window.pageYOffset - 74;
      window.scrollTo({
        top: Ycoords,
        behavior: "smooth"
      });
    }
  }, {
    key: "showErrorMessage",
    value: function showErrorMessage() {
      var emailErrorMessage = querySelector(this.selectors.emailError);
      emailErrorMessage.classList.add(this.modificators.active);
    }
  }, {
    key: "onFormSubmit",
    value: function onFormSubmit() {
      var contactForm = this.querySelector(this.selectors.form);
      var successMessage = this.querySelector(this.selectors.successContent);
      var baseMessage = this.querySelector(this.selectors.baseContent);
      var formData = new FormData(contactForm);
      var workShopPopup;

      if (this.closest('workshop-popup')) {
        workShopPopup = this.closest('workshop-popup');
      }

      fetch("/contact", {
        method: "POST",
        body: formData
      }).then(function (response) {
        if (response.ok) {
          // console.log('success');
          // console.log(response);
          baseMessage.classList.remove('active');
          successMessage.classList.add('active');

          if (workShopPopup) {
            workShopPopup.setStep_2();
          }

          return response.text();
        } else {
          throw new Error("Error");
        }
      })["catch"](function (error) {});
    }
  }, {
    key: "initListeners",
    value: function initListeners() {
      var _this2 = this;

      var contactForm = this.querySelector(this.selectors.form);
      var submitBtn = this.querySelector(this.selectors.submitButton);
      var email = this.querySelector(this.selectors.email);
      var dateInput = this.querySelector(this.selectors.date);
      var firstName = this.querySelector(this.selectors.firstName);
      var lastName = this.querySelector(this.selectors.lastName);
      var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      var parentThis = this;
      var emailError = this.querySelector(this.selectors.emailError);
      var termsError = this.querySelector(this.selectors.termsError);

      if (submitBtn) {
        var onHandleErrors = function onHandleErrors(event) {
          event.preventDefault();
          var checkbox = parentThis.querySelector(parentThis.selectors.checkbox);
          var emailInput = parentThis.querySelector(parentThis.selectors.email);
          var checkboxInput = checkbox.querySelector('input');

          if (!emailPattern.test(emailInput.value)) {
            emailError.classList.add(parentThis.modificators.active);
            setTimeout(function () {
              emailError.classList.remove(parentThis.modificators.active);
            }, 3000);
          } else if (!checkboxInput.checked) {
            termsError.classList.add(parentThis.modificators.active);
            setTimeout(function () {
              termsError.classList.remove(parentThis.modificators.active);
            }, 3000);
          } else {
            if (!contactForm.reportValidity()) {
              return;
            }

            _this2.onFormSubmit();
          }
        };

        submitBtn.addEventListener('click', onHandleErrors);
      }

      if (email) {
        email.addEventListener('input', function () {
          emailError.classList.remove(_this2.modificators.active);
        });
      }

      if (dateInput) {
        var separator = "-";
        var prevValue = "";
        var inputField = dateInput;
        inputField.addEventListener("input", function (e) {
          var inputValue = inputField.value;

          if (inputValue && inputValue.length < prevValue.length) {
            // Skip if the user is trying to delete characters
            prevValue = inputValue;
            return;
          }

          inputValue = inputValue.replace(/\D/g, "");

          if (inputValue.length >= 2) {
            inputValue = "".concat(inputValue.slice(0, 2), "/").concat(inputValue.slice(2));
          }

          if (inputValue.length >= 5) {
            inputValue = "".concat(inputValue.slice(0, 5), "/").concat(inputValue.slice(5));
          }

          var dateParts = inputValue.split('/');

          if (dateParts.length >= 1 && parseInt(dateParts[0]) > 12) {
            dateParts[0] = '12';
          }

          if (dateParts.length >= 2 && parseInt(dateParts[1]) > 31) {
            dateParts[1] = '31';
          }

          if (dateParts.length === 3 && parseInt(dateParts[2]) > new Date().getFullYear()) {
            dateParts[2] = new Date().getFullYear().toString();
          }

          inputField.value = dateParts.join('/');
          prevValue = inputField.value;
        });
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this3 = this;

      document.addEventListener("DOMContentLoaded", function () {
        _this3.formId = _this3.dataset.formId;

        _this3.initListeners();

        _this3.checkFormStatus();
      });
    }
  }]);

  return NewsletterSection;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (customElements.get('newsletter-section') === undefined) {
  customElements.define('newsletter-section', NewsletterSection);
}
/******/ })()
;